
import { Spinner } from "react-bootstrap";

export default function LoaderModal({ show }) {
  return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
            {show && (<div className="spinner-overlay">
                <Spinner animation="border" style={{ color: "#6929E2" }} />
                <p className="mt-3" style={{ marginLeft: "8px", color: "#6929E2", fontSize: '24px' }}> </p>
            </div>)}
            <style jsx="true">{`
        .spinner-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent background */
          z-index: 9999; /* Ensure it is above other content */
        }
      `}</style>
        </div>
    );
}